<template>
  <div>
    <ts-button outline color="info" @click.prevent="onShowModal">
      {{ $t('add_new') }}
    </ts-button>
    <br /><br />
    <ts-table-filter :columns="columns" :data="records">
      <template slot-scope="{ row }" slot="action">
        <div class="ts-flex ts-space-x-2 ts-justify-center ts-w-full">
          <a-popconfirm
            placement="leftTop"
            :title="$t('are_you_sure_to_delete')"
            :ok-text="$t('yes')"
            :cancel-text="$t('no')"
            @confirm="deleteRecord(row)"
          >
            <a href="#">
              <Icon type="ios-trash ts-text-red-500" size="20" />
            </a>
          </a-popconfirm>
        </div>
      </template>
    </ts-table-filter>

    <iModalWrapper
      v-model="show_modal"
      :title="$t('projectProfile.member')"
      width="40%"
    >
      <table class="ts-w-full">
        <thead>
          <tr>
            <th class="ts-uppercase ts-py-1 ts-bg-gray-100 ts-px-2">#</th>
            <th class="ts-uppercase ts-py-1 ts-bg-gray-100 ts-px-2">Name Kh</th>
            <th class="ts-uppercase ts-py-1 ts-bg-gray-100 ts-px-2">Name EN</th>
            <th class="ts-uppercase ts-py-1 ts-bg-gray-100 ts-px-2">Phone</th>
            <th class="ts-uppercase ts-py-1 ts-bg-gray-100 ts-px-2">
              Position
            </th>
          </tr>
          <tr>
            <th colspan="5" class="py-2">
              <input
                v-model="search"
                type="text"
                class="ts-px-2 ts-py-1 ts-rounded-md ts-border ts-w-full ts-outline-none"
                :placeholder="$t('search')"
              />
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(m, index) in memberList" :key="index" class="ts-border-b">
            <td class="ts-py-2 ts-px-2">
              <ts-checkbox
                style="margin-top: -11px;"
                v-model="memberAdded"
                :value="m.user_id"
              ></ts-checkbox>
            </td>
            <td class="ts-px-2">{{ m.employee_name_kh }}</td>
            <td class="ts-px-2">{{ m.employee_name_en }}</td>
            <td class="ts-px-2">{{ m.phone }}</td>
            <td class="ts-px-2">{{ m.position_name_en }}</td>
          </tr>
        </tbody>
      </table>
      <div class="ts-w-full ts-flex ts-justify-end">
        <ts-button color="primary" class="ts-mt-3" @click.prevent="addMember">{{
          $t('save')
        }}</ts-button>
      </div>
      <Spin v-if="loading" size="large" fix :show="true"></Spin>
    </iModalWrapper>
    <Spin v-if="loading" size="large" fix :show="true"></Spin>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import iModalWrapper from '../../components/i-modal-wrapper.vue'
import { includes } from 'lodash'
export default {
  components: {
    iModalWrapper
  },
  props: ['resources'],
  data() {
    return {
      search: '',
      loading: false,
      show_modal: false,
      memberResources: [],
      memberAdded: []
    }
  },
  computed: {
    records() {
      if (this.resources) {
        return this.resources.project_member
      }

      return []
    },
    memberList() {
      const filter = this.memberResources
        .filter(
          m =>
            !includes(
              this.records.map(el => el.user_id),
              m.user_id
            )
        )

        .filter(
          s =>
            (s.employee_name_kh ? s.employee_name_kh : '')
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (s.employee_name_en ? s.employee_name_en : '')
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            (s.position_name_en ? s.position_name_en : '')
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0
        )

      return filter
    },
    columns() {
      return [
        {
          title: this.$t('projectProfile.nameKh'),
          key: 'employee_name_kh',
          with: 120
        },
        {
          title: this.$t('projectProfile.nameEn'),
          key: 'employee_name_en',
          width: 130
        },
        {
          title: this.$t('projectProfile.phoneNumber'),
          key: 'phone'
        },
        {
          title: this.$t('projectProfile.position'),
          key: 'position_name_en'
        },
        {
          title: this.$t('actions'),
          slot: 'action',
          width: 130,
          class: 'ts-text-center'
        }
      ]
    }
  },
  methods: {
    ...mapActions('projectMgt/projectProfile', [
      'formViewModel',
      'updateMember'
    ]),
    onShowModal() {
      this.show_modal = true
      this.loading = true
      this.memberAdded = []
      this.formViewModel({
        fnName: 'member'
      })
        .then(response => {
          this.memberResources = response.data.member
        })
        .finally(() => (this.loading = false))
    },
    addMember() {
      if (!this.memberAdded) {
        return this.$toasted.error('No! member to add.')
      }
      const willAdded = this.memberResources
        .filter(m => includes(this.memberAdded, m.user_id))
        .map(el => ({
          user_id: el.user_id,
          user_name: el.user_name
        }))

      const oldMember = this.records.map(el => ({
        user_id: el.user_id,
        user_name: el.user_name
      }))
      this.loading = true
      this.updateMember({
        id: this.resources.project_id,
        data: {
          member: [...oldMember, ...willAdded]
        }
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetch')
          this.show_modal = false
          this.memberAdded = []
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    deleteRecord(record) {
      const updateMember = this.records
        .filter(m => m.user_id !== record.user_id)
        .map(el => ({
          user_id: el.user_id,
          user_name: el.user_name
        }))
      this.loading = true
      this.updateMember({
        id: this.resources.project_id,
        data: {
          member: updateMember
        }
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetch')
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style></style>
